import {computed, decorate, observable} from 'mobx';
import {faBrowser} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel} from './base';

export class Terminal extends BaseModel {
  static faIcon = faBrowser;

  searchableProperties = ['name'];

  static prepareApiPayload(model) {
    return {
      ...model,
      brokenReason: model.isBroken ? model.brokenReason : null,
    };
  }

  get hasTerminalWorkplaces() {
    return this.workplaceId || this.workplaceGroupId;
  }
}

decorate(Terminal, {
  id: observable,
  name: observable,
  isBroken: observable,
  brokenReason: observable,
  terminalLayoutId: observable,
  workplaceId: observable,
  workplaceGroupId: observable,
  hasTerminalWorkplaces: computed,
  ...Terminal.modelCreateDecoration,
  ...Terminal.modelUpdateDecoration,
});
